export const RegexHelper = {
	cpf: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
	cnpj: /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/,
	phone: /^\(\d{2}\) \d{5}-\d{4}$/,
	email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
	password:
		/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+]).{8,}$/,
};
